var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInstagramOval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30.0 30.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1554 L0,1554 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2842712,0 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 0,23.2842712 0,15 C0,6.71572875 6.71572875,0 15,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i2",
    x1: "3.5786px",
    y1: "26.4214px",
    x2: "24.8952667px",
    y2: "5.10473333px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE311",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB16",
    offset: "5.184586%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC125",
    offset: "13.81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE983C",
    offset: "24.81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5E5E",
    offset: "37.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2081",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9000DC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5133333,0 C14.3533333,0 16.66,2.30666667 16.66,5.14666667 L16.66,11.5133333 C16.66,14.3533333 14.3533333,16.66 11.5133333,16.66 L5.14666667,16.66 C2.30666667,16.66 0,14.3533333 0,11.5133333 L0,5.14666667 C0,2.30666667 2.30666667,0 5.14666667,0 Z M11.5066667,1.86 L5.14,1.86 C3.32,1.86 1.84666667,3.34 1.84666667,5.15333333 L1.84666667,11.52 C1.84666667,13.34 3.32666667,14.8133333 5.14,14.8133333 L11.5066667,14.8133333 C13.3266667,14.8133333 14.8,13.3333333 14.8,11.52 L14.8,5.15333333 C14.8,3.33333333 13.32,1.86 11.5066667,1.86 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26,0 C6.60666667,0 8.52,1.91333333 8.52,4.26 C8.52,6.60666667 6.60666667,8.52 4.26,8.52 C1.91333333,8.52 0,6.60666667 0,4.26 C0,1.91333333 1.91333333,0 4.26,0 Z M4.26,1.67333333 C2.83333333,1.67333333 1.67333333,2.83333333 1.67333333,4.26 C1.67333333,5.68666667 2.83333333,6.84666667 4.26,6.84666667 C5.68666667,6.84666667 6.84666667,5.68666667 6.84666667,4.26 C6.84666667,2.83333333 5.68666667,1.67333333 4.26,1.67333333 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.719916835,0 C1.11751592,0 1.43983367,0.322317746 1.43983367,0.719916835 C1.43983367,1.11751592 1.11751592,1.43983367 0.719916835,1.43983367 C0.322317746,1.43983367 0,1.11751592 0,0.719916835 C0,0.322317746 0.322317746,0 0.719916835,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-453.0 -471.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.0 200.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0 60.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 26.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 135.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.0 50.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 30,0 30,30 0,30 0,0",
    stroke: "none",
    fill: "url(#i2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.666666666666668 6.666666666666668)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.006666666666667709 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16.66,0 16.66,16.66 0,16.66 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.073333333333334 4.073333333333331)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 8.52,0 8.52,8.52 0,8.52 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.976739999999936 3.2342800000001914) rotate(-9.20796905371943)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-5.68434189e-14,1.13686838e-13 1.43983367,1.13686838e-13 1.43983367,1.43983367 -5.68434189e-14,1.43983367 -5.68434189e-14,1.13686838e-13",
    stroke: "none",
    fill: "#FFFFFF"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagramOval);
export default __webpack_public_path__ + "static/media/icInstagramOval.2096ede5280998bcefde0847b1ba3c4b.svg";
export { ForwardRef as ReactComponent };